var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70667 9.29297C2.14328 9.29297 0.875 10.5669 0.875 12.1398V21.0077H6.53716V12.1398C6.53716 10.5681 5.27005 9.29297 3.70549 9.29297H3.70667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35583 8.6104C5.87788 8.24923 6.82055 6.71596 6.4613 5.18573C6.10206 3.6555 4.57696 2.70779 3.05489 3.06896C1.53283 3.43013 0.590167 4.9634 0.949408 6.49365C1.30865 8.02385 2.83375 8.97156 4.35583 8.6104Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1689 2.99219H7.53711V21.0069H14.1689C19.1167 21.0069 23.1277 16.9745 23.1277 12.0002C23.1277 7.02583 19.1167 2.99219 14.1689 2.99219ZM14.4008 14.8458H13.1981V9.15329H14.4008C15.9642 9.15329 17.2325 10.4272 17.2325 12.0002C17.2325 13.5731 15.9654 14.847 14.4008 14.847V14.8458Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.31e217aeb824420eb413e2f43ed68e78.svg";
export { ForwardRef as ReactComponent };